import * as React from "react";
import { Redirect, Route, RouteProps } from "react-router-dom";

import { FindAppNavigationItemFromRoute } from "../app-navigation";
import { ERoutes } from "../AppRouter";
import { useAuth } from "../contexts";
import { useCommonHooks } from "../hooks";

interface IProtectedRouteProps extends RouteProps {
  redirectToRoute?: string;
}

export const ProtectedRoute: React.FunctionComponent<IProtectedRouteProps> = ({
  redirectToRoute,
  ...routeProps
}) => {
  const { hasAction, isLoggedIn } = useCommonHooks();

  const currentNavItem = React.useMemo(
    () => FindAppNavigationItemFromRoute(routeProps.path as string),
    [routeProps]
  );

  const hasAccess = React.useMemo(
    () =>
      isLoggedIn &&
      (!currentNavItem ||
        !currentNavItem.actions ||
        hasAction(currentNavItem.actions)),
    [currentNavItem, hasAction, isLoggedIn]
  );

  if (hasAccess) {
    return <Route {...routeProps} />;
  } else {
    let to = redirectToRoute ?? ERoutes.unauthorized;
    console.log("You are not authorized, redirect to " + to);
    return <Redirect to={to} />;
  }
};
